module.exports = __webpack_public_path__ + "img/goods.95ee2da6.svg";